import React, { useRef } from "react";
import { Content, ContentBox, List, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com6 = ({ t }) => {
  const ref1 = useRef();
  const ref2 = useRef();

  useScrollFadeIn(ref1, ref2);
  return (
    <Wrapper>
      <TextBox>
        <div>
          <span>{t("6-1")}</span>
        </div>
      </TextBox>
      <Content>
        <ContentBox ref={ref1} className="fade-in">
          <div>
            <span>{t("6-2")}</span>
          </div>
          <div>
            <span>{t("6-3")}</span>
          </div>
          <List>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt="앞에 점"
            />
            <div>
              <span>{t("6-4")}</span>
              <span>{t("6-5")}</span>
            </div>
          </List>
        </ContentBox>
        <ContentBox ref={ref2} className="fade-in">
          <div>
            <span>{t("6-6")}</span>
          </div>
          <div>
            <span>{t("6-7")}</span>
          </div>
          <List>
            <img
              loading="lazy"
              src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/39aa0bbdSketchDrop_2.svg"
              alt="앞에 점"
            />
            <div>
              <span>{t("6-8")}</span>
              <span>{t("6-9")}</span>
            </div>
          </List>
        </ContentBox>
      </Content>
    </Wrapper>
  );
};

export default Com6;
